(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.JobsUsers = {
        options: {
            recaptchaKey: null,
            token: null,
            form: null,
            textarea: null,
        },
        recaptchaRefresh: function() {
            grecaptcha.execute(this.options.recaptchaKey, { action: 'submit' }).then(function (token) {
                document.getElementById('recaptcha-token').value = token
            });
        },
        toggleTextarea: function(e) {
            if (e.target.checked) {
                this.options.textarea.required = true
                this.options.textarea.classList.remove('d-none')
            } else {
                this.options.textarea.required = false
                this.options.textarea.classList.add('d-none')
                this.options.textarea.value = ''
            }
        },
        form: {
            submit: async function(e) {
                e.preventDefault();
                const message = document.querySelector('.message')
                const action = this.options.form.getAttribute('action')

                message.classList.remove('error')
                message.classList.add('d-none')

                try {
                    await this.recaptchaRefresh.bind(this)();
                    const response = await fetch(action, {
                        headers: {
                            'Content-Type': 'application/json',
                            "X-CSRF-Token": this.options.token
                        },
                        method: "POST",
                        body: JSON.stringify({
                            recaptcha_token: document.getElementById('recaptcha-token').value,
                            ju_email: document.getElementById('landing-jobs-email').value,
                            ju_privacy: document.getElementById('landing-jobs-privacy').checked,
                            ju_marketing: document.getElementById('landing-jobs-marketing').checked,
                            ju_interests: Array.from(
                                document.querySelectorAll('form .list .item .form-check-input:checked')
                            ).map(item => item.value),
                            ju_other: document.getElementById('other').value,
                        })
                    })

                    if (!response.ok) {
                        const body = await response.json()

                        message.textContent = body.errors[0]
                        message.classList.add('error')
                        message.classList.remove('d-none')

                        return null
                    }

                    document.querySelectorAll('form .list .item .form-check-input').forEach(item => {
                        item.checked = false
                    })
                    this.options.textarea.required = false
                    this.options.textarea.classList.add('d-none')
                    this.options.textarea.value = ''
                    document.getElementById('landing-jobs-email').value = ''
                    document.getElementById('landing-jobs-privacy').checked = false
                    document.getElementById('landing-jobs-marketing').checked = false

                    bootstrap.Modal.getInstance(document.getElementById('modal-jobs-user')).hide()
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-jobs-user-thank-you')).show()

                } catch (error) {
                    console.error(error.message)
                    return null
                }
            },
        },
        events: function() {
            document.querySelector('form .list .item:last-of-type .form-check-input').addEventListener(
                'change',
                this.toggleTextarea.bind(this)
            )
            this.options.form.addEventListener('submit', this.form.submit.bind(this));
            grecaptcha.ready(this.recaptchaRefresh.bind(this));
        },
        init: function(recaptchaKey) {
            this.options.recaptchaKey = recaptchaKey
            this.options.token = document.querySelector('meta[name="csrf-token"]').content
            this.options.form = document.querySelector('form')
            this.options.textarea = document.querySelector('form textarea')

            this.events()
        },
    };

})));
